import { useEffect, useState } from 'react';
import LocalStorageType from '../constants/LocalStorageType';
import SaaSBillingService from '../services/superadmin/SaaSBillingService';
import { hasMenuAccess } from '../utils/ModuleAccessUtils';

/** Chave do submenu no plano, no mesmo formato do SideBar (ex.: cash_flow.advance.view). */
const planMenuKey = (module, menuKey) => `${String(module).toLowerCase()}.${menuKey}.view`;

/**
 * Diz se o usuário logado pode usar um submenu, pela mesma regra do menu lateral: o plano
 * precisa ter o submenu e o grupo precisa liberá-lo.
 *
 * Serve para atalhos de um recurso que aparecem fora da própria tela, como o consumo do
 * colaborador lançado pela tela de Caixas. Sem isso, o menu aparecia bloqueado e o atalho
 * continuava funcionando. Enquanto o plano é consultado, responde "não", para o botão não
 * aparecer e sumir em seguida. O backend valida de novo (ModuleAccessGuard.requireMenu).
 */
const useMenuAccess = (module, menuKey) => {
    const [planAllows, setPlanAllows] = useState(null);

    useEffect(() => {
        let user = null;
        try {
            user = JSON.parse(localStorage.getItem(LocalStorageType.USER_DETAILS));
        } catch {
            user = null;
        }

        // O super admin não é cliente: o plano da empresa acessada não o limita.
        if (user?.superAdmin) {
            setPlanAllows(true);
            return;
        }

        let active = true;
        SaaSBillingService.currentPlanPermissions()
            .then(response => {
                if (!active) return;
                // restricted=false é o mesmo "sem restrição de plano" que o SideBar respeita.
                const data = response.data || {};
                setPlanAllows(!data.restricted || (data.keys || []).includes(planMenuKey(module, menuKey)));
            })
            // Falha na consulta segue o SideBar, que também não trava o menu nesse caso.
            .catch(() => active && setPlanAllows(true));

        return () => {
            active = false;
        };
    }, [module, menuKey]);

    return planAllows === true && hasMenuAccess(module, menuKey);
};

export default useMenuAccess;
